import React, { Component } from 'react';
import { Table, Row, Col, Button, Space, Spin, Alert, DatePicker, Popover } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import moment from 'moment'
import _ from 'lodash';

const columns = (props) => {
  
  return [
  {
    title: 'Account Name',
    dataIndex: 'display_name',
    key: 'display_name',
    width: '45%',
      render: (text, record) => { return <a target="_blank" href={`/accounting/reports/ledgerentries-details?to_date=${props?.date?.format('ll')}&account_id=${record.id}`}>{text}</a>}
      

  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: '15%',

  },
    // {
    //   title: 'Total Value',
    //   dataIndex: 'totalValue',
    //   width: '20%',
    //   key: 'totalValue',
    //   className: 'column-money',
    //   align: 'right',

    //   render: (text, record) => format_currency_simple(text)

    // },
  {
    title: 'Debit Balance',
    dataIndex: 'debit_balance',
    width: '20%',
    key: 'debit',
    className: 'column-money',
    align: 'right',
    
    render: (text, record) => {
      return !record.normal_credit_balance && nonZeroAmount(record.totalValue) ? 
        <AccountBalanceInfo name={record.display_name} subAccountTotal={record.totalValue} selfTotal={text} />
        : 
        format_currency_simple(text)
      }

  },
  {
    title: 'Credit Balance',
    dataIndex: 'credit_balance',
    width: '20%',
    key: 'credit',
    className: 'column-money',
    align: 'right',
    // render: (text, record) => format_currency_simple(text, false)
    render: (text, record) => {
      return (record.normal_credit_balance && nonZeroAmount(record.totalValue) ?
        <AccountBalanceInfo name={record.display_name} subAccountTotal={record.totalValue} selfTotal={text}  />
        :
        format_currency_simple(text))
    }

  },
];
}

const AccountBalanceInfo = ({ name, subAccountTotal, selfTotal }) => {
  // debugger;
  // console.log('name, subAccountTotal, selfTotal')
  // console.log("name", name, "subAccountTotal", subAccountTotal, "selfTotal", selfTotal)
  return(
    <>
      <div style={{ color: '#bbabab' }}> {format_currency_simple(safeNumber(subAccountTotal) + safeNumber(selfTotal))} </div>
      {
        nonZeroAmount(selfTotal) 
        ? 
        (
            <Popover title={name} content={<CalculationBreakup subAccountTotal={subAccountTotal} selfTotal={selfTotal} />} >
            <div style={{ color: '#ea817b' }}>{format_currency_simple(selfTotal)}</div> 
          </Popover>) 
        : 
        ''
      }
    </>)
  
}


const CalculationBreakup = ({ subAccountTotal, selfTotal } ) => {

  return(
    <table className='bordered'>
    <tbody>
    <tr>
        <td align="left">Sub Accounts Total</td>
        <td align="right">{format_currency_simple(subAccountTotal)}</td>
    </tr>
      <tr>
        <td align="left">Self Total</td>
        <td style={{paddingBottom: '5px'}} align="right">{format_currency_simple(selfTotal)}</td>
      </tr>
      <tr style={{ }}>
        <td align="left" >Grand Total</td>
        <td align="right" style={{ borderTop: '1px solid grey', borderTop: '1px solid grey', paddingTop: '10px' }}>{format_currency_simple(safeNumber(subAccountTotal) + safeNumber(selfTotal))}</td>
      </tr>
      </tbody>
    </table>
  );
  
}


class TrialBalance extends Component {

  constructor(props) {
    super(props);
    const excelData = null
    const data = null // [{ display_name: '', id: 1, children: [{ display_name: '', id: 2}]}]
    this.state = {
      data,
      excelData,
      date: moment(),
      loading: true,
      old: false,
    };
  }

  createDataTree(dataset) {
    let hashTable = Object.create(null);
    dataset.forEach(aData => hashTable[aData.id] = { ...aData, children: [] });
    let dataTree = [];
    dataset.forEach(aData => {

      if (aData?.parent_id) hashTable[aData.parent_id].children.push(hashTable[aData.id]);
      else dataTree.push(hashTable[aData.id]);
    });
    return dataTree;
  }

  setupAjaxCall(type){
    const {date} = this.state
    const loadurl = '/accounting/reports/' + type + '?sendjson=true&to_date=' + date.format('ll');
    return $.ajax({
      type: "GET",
      url: loadurl,
      dataType: 'text'
    })
  }
  
  componentDidMount() {
    this.loadData()

  }

  sumUp = (object) => {
    object.totalValue = 0.0;

    for (const child of object.children) {
      object.totalValue += this.sumUp(child);
    }
    return object.totalValue + safeNumber(object.normal_credit_balance ? object.credit_balance : object.debit_balance);
}

walk = (nodes) => {
  const $this = this;
  let node;
  node = nodes
  if (Array.isArray(nodes)) node = nodes[0]

  
  if (node.children !== undefined) {
    node.children.forEach(function (child) {
      $this.walk(child);
    });
  }
  // alert(node.name)
  // console.log(node.display_name);
}

  loadData = () => {


    this.setState({ loading: true });
    var $this = this;

    const allData = this.setupAjaxCall('all');
    $.when(allData).done(function (report) {

      const excelData = JSON.parse(report) 
      const tree = $this.createDataTree(excelData);
      // $this.walk(tree);
      // const node = tree[0]
      // const totalofall = $this.sumUp(node);
      let sumUpTree = []
      for(const root of tree){
        $this.sumUp(root)
        sumUpTree.push(root);
      }
      // console.log(sumUpTree);
// debugger
      $this.setState({ data: sumUpTree, excelData, loading: false });
      
    })

  }
  
  onChangeDate = (date) => {
    const loadData = this.loadData;
    this.setState({ date }, () => loadData() );

  }

  downloadExcel = () => {
    
    const { excelData } = this.state;
    const data = excelData.map(d => [" ".repeat(d.depth * 2) + d.display_name, d.type, nonZeroAmount(d.debit_balance), nonZeroAmount( d.credit_balance)])
     
    // const data = this.state.excelData;


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Trial Balance', 
      { 
        views: [{ showGridLines: false }],
        headerFooter: { firstHeader: "Trial Balance", firstFooter: "Biscraft Powered" },
        style: {
          font: {
            name: 'Calibri',
            family: 4,
            size: 16,
          }
        },
      }
    );
    // worksheet.properties.defaultRowHeight = 15;
    // worksheet.getCell('A1').note = 'Hello, ExcelJS!';
    const table = worksheet.addTable({
      name: 'TrialBalance',
      displayName: 'Trial Balance As On ' + moment( this.state.date).format('lll'),
      ref: 'A1',
      headerRow: true,
      totalsRow: true,
      
      style: {
        // theme: 'TableStyleDark3',
        showRowStripes: true,
        font: {
          name: 'Calibri',
          family: 4,
          size: 30,
          underline: true,
          bold: true
        }
      },
      columns: [
        { name: 'Account Name', totalsRowLabel: 'Totals:', filterButton: true },
        { name: 'Account Type', totalsRowLabel: '', filterButton: true },
        { name: 'Debit Balance', totalsRowFunction: 'sum', filterButton: false },
        { name: 'Credit Balance', totalsRowFunction: 'sum', filterButton: false },
      ],
      rows:   data,
    });

    const font = { name: 'Calibri', size: 12 };

    var nameCol = worksheet.getColumn(1);
    var typeCol = worksheet.getColumn(2);
    var debitCol = worksheet.getColumn(3);
    var creditCol = worksheet.getColumn(4);

    [nameCol, typeCol, debitCol, creditCol].forEach( col =>
    {
      col.width = 25;
      col.font = font;
    })
    nameCol.width = 40;
    nameCol.alignment = { wrapText: true };

    // debitCol.eachCell(function (cell, rowNumber) {
    //   // ...
    // });
    debitCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    creditCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    table.commit();


    const filename = 'trial_balance_'
    return workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], {
        type: "application/octet-stream"
      }), `${filename}-${moment().format('YYYY-MM-DD__HH:mm:ss')}.xlsx`);
    });
  }

  render() {  

    const { data, date, loading, rowSelection, checkStrictly, excelData } = this.state
    if (!data) return <Spin spinning={loading} size='large' />;
    return (
      <div>
        <Space>
        <Alert message={`Trial Balance as on ${date.format('ll')} `} type="info" showIcon >
        </Alert>
        <DatePicker placeholder="Change Date" onChange={this.onChangeDate} />
          <Button onClick={this.downloadExcel} icon={<FileExcelOutlined />} type="primary" > Download </Button>
        </Space>

        <Table
          columns={columns({date})}
          dataSource={data}
          rowSelection={{ ...rowSelection, checkStrictly }}
          defaultExpandAllRows={true}
          pagination={null}
          loading = {loading}
          rowKey="id"
          size="small"
          bordered
          sticky
            scroll={{ y: window.screen.height - 200}}
          summary={() => {
            const debit_total = sumArrayValue(excelData, 'debit_balance')
            const credit_total = sumArrayValue(excelData, 'credit_balance')

            return(
            
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}></Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right"><b> {format_currency_simple( debit_total )}</b>
                  
              </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right"><b> {format_currency_simple( credit_total )}</b></Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        
        }
        />

      </div>
    );
  }
}

export default TrialBalance;
